import keyMirror from 'keymirror';

const tripTypes = keyMirror({
  ROUND_TRIP: null,
  ONE_WAY: null,
  MULTI_DESTINATION: null,
  ROUNDTRIP: null,
  ONEWAY: null,
  MULTICITY: null,
});

export const tripTypeNames = {
  [tripTypes.ROUND_TRIP]: 'Round Trip',
  [tripTypes.ROUNDTRIP]: 'Round Trip',
  [tripTypes.ONE_WAY]: 'One Way',
  [tripTypes.ONEWAY]: 'One Way',
  [tripTypes.MULTI_DESTINATION]: 'Multi-city',
  [tripTypes.MULTICITY]: 'Multi-city',
};

export default tripTypes;
